import {
  ALICE_BLUE,
  MAIN_BLUE,
  NOTES_COLOR,
  PALE_CORNFLOWER_BLUE,
  SOLITUDE,
  TEXT_COLOR,
} from '../../theme';

export const colors = {
  brand: MAIN_BLUE,
  brandSoft: ALICE_BLUE,
  brandMedium: PALE_CORNFLOWER_BLUE,
  text: TEXT_COLOR,
  textMuted: NOTES_COLOR,
  border: SOLITUDE,
  surface: '#fff',
};

export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
};

export const radius = {
  medium: '10px',
  large: '16px',
};

export const shadows = {
  card: '0 1px 2px 0 rgba(0, 0, 0, 0.03)',
};
